import transitionPage from "../../../components/transitionPage/index";

export default {
  name: "tickets",
  components: { transitionPage }
};
